import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { filter, first, map, tap } from 'rxjs';
import { FeatureFlagsService } from './feature-flags.service';
import { FeatureFlagKeyType } from './feature-flags.types';

/**
 * Guard to validate routing according to feature flags
 * @param route route to activate
 * @returns if can activate
 */
export const featureFlagGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const featureFlagsService = inject(FeatureFlagsService);
    const featureFlagKey = route.data['featureFlag'] as FeatureFlagKeyType;
    const featureFlagSignal = featureFlagsService.getFeatureFlagSignal<boolean | undefined>(featureFlagKey);
    const featureFlag$ = toObservable(featureFlagSignal);
    return featureFlag$.pipe(
        filter((isEnabled): isEnabled is boolean => isEnabled !== undefined), // espera valor válido
        first(),
        tap(isEnabled => {
            if (!isEnabled) {
                router.navigate(['']);
            }
        }),
        map(isEnabled => isEnabled)
    );
};
